var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrganize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29,11.71L2.59,7,7.29,2.29l1.41,1.41-2.29,2.29h13.59v2H6.41l2.29,2.29-1.41,1.41Zm9.41,.59l-1.41,1.41,2.29,2.29H4v2h13.59l-2.29,2.29,1.41,1.41,4.71-4.71-4.71-4.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganize);
export default __webpack_public_path__ + "static/1773309961/media/icon-organize.d3b23a2e96434621b97c825398a5b8e5.svg";
export { ForwardRef as ReactComponent };